import { useState } from "react";
import {
  completeForgotPassword,
  forgotPassword,
} from "../cognito/kahunUserAuth";

interface useNewPasswordProps {
  onResetComplete: () => void;
  onError: (errMsg: string) => void;
  useSessionStorage?: boolean;
}

export const useNewPassword = (props: useNewPasswordProps) => {
  const [password, setPassword] = useState("");
  const [newPasswordRequested, setNewPasswordRequested] = useState(false);
  const [verifyPassword, setVerifyPassword] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const { onError, onResetComplete } = props;
  const onForgetPassword = async () => {
    setLoading(true);
    onError("");
    try {
      await forgotPassword(email);
      setNewPasswordRequested(true);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      onError(e as string);
    }
  };

  const onChange = async () => {
    setLoading(true);
    onError("");
    try {
      await completeForgotPassword(email, verificationCode, password);
      setLoading(false);
      onResetComplete();
    } catch (e) {
      setLoading(false);
      onError(e as string);
    }
  };

  return {
    setEmail,
    setPassword,
    setVerifyPassword,
    setVerificationCode,
    onForgetPassword,
    onChange,
    newPasswordRequested,
    loading,
    disableSend:
      loading ||
      (newPasswordRequested
        ? verifyPassword !== password || !verificationCode
        : !email),
    wrongPassword: password !== verifyPassword,
  };
};
